import React, { useState, useEffect, useContext } from "react";
import TemplateLandingPage from "./TemplateLandingPage";
import { useLocation } from "react-router-dom";
import "../../styles/pages/TemplateManager.scss";
import "react-toastify/dist/ReactToastify.css";
import ValueContext from "../../ContextAPi/appContext";
import DashboardNewHeader from "../../components/Manager/Header";
import { getSizesData } from "../../services/apis";
const LandingPage = (props) => {
  const appData = useContext(ValueContext);
  const [isOpen, setIsOpen] = useState(true);
  const [activeButton, setActiveButton] = useState(1);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const type = queryParams.get("type");
  const docid = queryParams.get("docid");
  const [openModalOnLoad, setopenModalOnLoad] = useState(false);

  const fetchAllSizesBanner = () => {
    getSizesData(docid, (response, err) => {
      if (response.status === 200) {
        const sizes = response.data;
        const isBannerAlreadyCreated = Object.keys(sizes).length !== 0;
        if (!isBannerAlreadyCreated) setopenModalOnLoad(true);
      } else {
        setopenModalOnLoad(true);
      }
    });
  };

  useEffect(() => {
    const isWebActionBanner =
      location.pathname === "/webaction" &&
      String(type || "").toUpperCase() === "BANNER" &&
      !!docid;

    if (isWebActionBanner) fetchAllSizesBanner();
  }, [location.pathname, type, docid]);

  const toggleLandingPage = (page) => {
    appData.setBanner(page === "banner" ? true : false);
    setActiveButton(1);
    if (page === "banner") {
      setIsOpen(true);
    } else if (page === "template") {
      setIsOpen(false);
    }
  };
  return (
    <>
      <div className="templateLandingPage">
        <div>
          <DashboardNewHeader
            setBanner={appData.setBanner}
            banner={appData.banner}
            toggleLandingPage={toggleLandingPage}
            appData={appData}
          />
          <TemplateLandingPage
            banner={appData.banner}
            setBanner={appData.setBanner}
            setIsOpen={setIsOpen}
            isOpen={isOpen}
            activeButton={activeButton}
            setActiveButton={setActiveButton}
            toggleLandingPage={toggleLandingPage}
            appData={appData}
            openModalOnLoad={openModalOnLoad}
            setopenModalOnLoad={setopenModalOnLoad}
          />
        </div>
      </div>
    </>
  );
};

export default LandingPage;
